module.exports = __webpack_public_path__ + "img/about-right.ca8002a3.png";